import * as z from "zod/v4";
import { pricingInclusionMode } from "./pricing-inclusion-mode";

/**
 * Upsert by `(teamId, sourceMarketId)`. Identity fields (catalog/price-list
 * gids, currency) are always written. Config fields (enabled, inclusion_mode,
 * markup_rate) only update when explicitly provided so partial updates are
 * safe. Markup rate is a decimal string ("1.000000" = no markup).
 */
export const upsertRedoMarket = {
  name: "upsertRedoMarket" as const,
  input: z.object({
    teamId: z.string(),
    source: z.string(),
    sourceMarketId: z.string(),
    sourceCatalogId: z.string().nullable(),
    sourcePriceListId: z.string().nullable(),
    currency: z.string(),
    enabled: z.boolean().optional(),
    inclusionMode: pricingInclusionMode.optional(),
    markupRate: z.string().optional(),
  }),
  output: z.object({
    id: z.string(),
    enabled: z.boolean(),
    inclusionMode: pricingInclusionMode,
    markupRate: z.string(),
  }),
};
